/* eslint-disable no-undef */
import React, { useState } from 'react';
import {
    HamBurgerButton,
    TitleTag,
    UserProfileContainer,
    HeaderDiv,
    HeaderWrapper,
    DismissContainer,
    StyledMoreDistrictSpan,
    CondensedViewToggleButton,
    SwitchLable,
} from './Header.styled';

import { Link, useHistory, } from 'react-router-dom';
import UserPanel from '../userPanel/UserPanel';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
    getPageVisibilityRule,
    resetCalendarFilterDataAfterImpersonation,
    setActiveNavLink,
    setFilters,
} from 'src/pages/home/redux/actions';
import {
    updateBannerLength,
    getBannerDetails,
    showDismissedBanner,
    hideDismissedBanner,
    getHybrisUserDetails,
    setIsCondensedView,
    setIsHideCondensedView,
    getConfigurations,
    resetBannerData,
} from 'src/common/redux/actions';
import {
    checkImpersonationActive,
    hideScrolling,
    isMobileDevice,
    navigateWithBusinessLogic,
    resumeScrolling,
    getRoutePathWithParams,
    checkProxyActive,
    getUserDetails,
    isMobileView,
    navLinkSelectHandler,
    removeImperonatedUserDetail,
    restoreAccountFilterStateAfterImpersonation,
    restorePhysicianFilterStateAfterImpersonation,
    restoreOrderFilterStateAfterImpersonation,
    logErrorToConsole,
    getWcmsHostName,
} from 'src/utils/util';
import {
    setRoutePathForSSUnsavedChangesPopUp,
    setScheduleSurgeryUnsavedChangesPopUp,
} from 'src/pages/scheduleSurgery/redux/actions';
import {
    setRoutePathForEquityUnsavedChangesPopUp,
    setEquityUnsavedChangesPopUp,
} from 'src/pages/equity/redux/actions';
import Banner from 'src/common/refactoredComponents/banner/Banner';
import axios from 'src/api/Api';
import ConfirmationPopUp from 'src/common/components/banner/ConfirmationPopUp';
import { invalidateImpersonation } from 'src/pages/impersonation/redux/actions';
import { terminateProxy } from 'src/pages/more/pages/proxies/redux/action/index.js';
import { setShowUnsavedReportUsageChangesPopUp } from 'src/pages/reportUsage/redux/action/actionCreators';
import {
    terminateAdminImpersonation,
    setPopDone,
    setFilterAppliedView,
    setAppliedFilter,
    setFilterAfterImpersonation,
    setAdminFilterParamValues,
} from 'src/pages/admin/redux/action/index.js';
import { setImpersonateCheckAction } from 'src/pages/impersonation/redux/actions/index.js';
import {
    CC_USER_ROLE,
    CSR_USER_ROLE,
    FIA_USER_ROLE,
    FIM_USER_ROLE,
    ITA_USER_ROLE,
    MENU
} from 'src/constants/appConstants';
import {
    getFilterData,
    setSelectedViews,
} from './../../../pages/admin/redux/action/index';
import {
    setReceiveSetUnsavedChangesPopup,
    setRoutePathForReceiveSetUnsavedChangesPopUp,
} from 'src/pages/receiveSets/redux/actions';
// import { sideNavLinksWCMSLinks } from 'src/constants/wcmsRedirectionLinks';
import {
    setConsignmentAddUnsavedChangesPopUp,
    setRoutePathForConsignmentAddUnsavedChangesPopUp,
} from 'src/pages/consignmentAdd/redux/actions';
import { clearProductsGuideData } from 'src/pages/more/pages/productGuide/redux/action';
import { setDeniedOverrideClicked } from 'src/pages/orders/redux/actions';
import { useTranslation } from 'react-i18next';
import Switch from '@material-ui/core/Switch';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { makeStyles } from '@material-ui/core';
import { X_SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { updateFilter } from 'src/pages/more/redux/actions';

const Header = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation();
    const location = useLocation();
    const pageIdentifier = location.pathname;

    const condensedView = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.condensedView
    );
    const isImpersonatedCondensedView = useSelector(
        (state) =>
            state.impersonatedUserDataReducer.hybrisUserDetails.condensedView
    );
    const hideCondensedView = useSelector(
        (state) => state.getSettingsReducer.hideCondensedViewToggle
    );
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const isHideCondensedView = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.hideCondensedViewToggle
    );
    // const winWidth = window.innerWidth;
    // const isDesktopView = winWidth >= sizes.mediumDevice;
    // const isMobileView = winWidth < sizes.smalDevice;
    const [showConfirmationMsg, setShowConfirmationMsg] = useState(true);
    const [condensedViewState, setCondensedViewState] = useState('');
    const [hideCondensedViewState, setHideCondensedViewState] = useState('');
    const [isMobile, setIsMobile] = useState(isMobileView() || isMobileDevice());

    const surgeryCUInProgress = useSelector(
        (state) => state.surgeryReducer.surgeryCUInProgress
    );
    const equityCUInProgress = useSelector(
        (state) => state.equityReducer.equityCUInProgress
    );
    const consignmentAddCUInProgress = useSelector(
        (state) => state.consignmentAddReducer.consignmentAddCUInProgress
    );
    const settingUpdateInProgress = useSelector(
        (state) => state.getSettingsReducer.settingUpdateInProgress
    );
    const newZIndex = useSelector(
        (state) => state.ordersListReducer.dynamicZIndex
    );
    const ImpersonationEndStatus = useSelector(
        (state) => state.invalidateImpersonationReducer.statusCode
    );
    const adminImperonationEndStatus = useSelector(
        (state) => state.AdminProxyReducer.terminationStatusCode
    );
    const totalDeniedOrder = useSelector(
        (state) => state.ordersListReducer.totalDeniedOrder
    );

    const userDetailsAvailable = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.uid
    )
        ? true
        : false;

    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );
    const confirmationBanner = useSelector(
        (state) => state.loginReducer.confirmationBanner,
        shallowEqual
    );
    const infoBanner = useSelector(
        (state) => state.loginReducer.infoBanner,
        shallowEqual
    );
    const isDestructiveEnabled = useSelector(
        (state) => state.loginReducer.isDestructiveEnabled
    );

    const isDestructive =
        isDestructiveEnabled ||
        (!checkProxyActive() &&
            !checkImpersonationActive() &&
            (bannerInfo || []).filter(
                (item) => item.messageType === 'userDestructiveMessage'
            ).length > 0);

    const bannerFrequency = useSelector(
        (state) => state.loginReducer.bannerFrequency
    );

    const isImpersonationActive = useSelector(
        (state) => state.impersonationReducer.isImpersonationActive
    );

    useEffectWithErrorLogging(() => {
        const queryParams = new URLSearchParams(location.search);
        const hasImpersonatedFlag =
            queryParams.get('impersonatedFlag') === 'true';
        const hasImpersonatedUser = Boolean(
            queryParams.get('impersonatedUser')
        );

        if (hasImpersonatedFlag && hasImpersonatedUser) {
            if (!isImpersonationActive) {
                dispatch(
                    setImpersonateCheckAction({
                        isImpersonationActive: true,
                    })
                );
            }
        } else if (isImpersonationActive) {
            dispatch(
                setImpersonateCheckAction({
                    isImpersonationActive: false,
                })
            );
        }
    }, [dispatch, isImpersonationActive, location.search]);

    const dismissedBanner = useSelector(
        (state) => state.loginReducer.showDismissedBanner
    );
    let proxyUserImpersonation = sessionStorage.getItem('ProxyUser');
    const impersonatedUserName = useSelector(
        (state) => state.impersonatedUserDataReducer.displayName
    );
    const impersonatedUserDistricts = useSelector(
        (state) => state.impersonatedUserDataReducer.districts || []
    );

    const orderStatus = useSelector(
        (state) => state.reportUsageRootReducer.orderStatus
    );

    const impersonatedUserRole = useSelector(
        (state) => state.impersonatedUserDataReducer.employeeRole
    );

    const usageOrderSubmission = useSelector(
        (state) => state.reportUsageRootReducer.usageOrderSubmission
    );
    const proxyTerminationStatus = useSelector(
        (state) => state.InitiateProxyReducer.terminationStatusCode
    );
    const isSubmitClicked = useSelector(
        (state) => state.reportUsageRootReducer.isSubmitClicked
    );
    const isCancelUsageSubmitted = useSelector(
        (state) => state.noUsageToReportReducer?.cancelUsageResponse?.statusCode
    );
    const isInReportUsageSubmitScreen =
        isSubmitClicked ||
        orderStatus?.status ||
        (usageOrderSubmission &&
            (usageOrderSubmission.statusCode ||
                usageOrderSubmission.errorCode) &&
            usageOrderSubmission.clickedBtn === 'submit');

    const [bannerDisplay, setBannerDisplay] = useState([]);
    const [confirmationMessage, setConfirmationMessage] = useState([]);
    const [intervalId, setIntervalId] = useState('');
    const [showAnimation, setShowAnimation] = useState(false);
    const [animationId, setAnimationId] = useState('');
    const [isImpersonated, setIsImpersonated] = useState(isImpersonationActive);
    const isAuthenticated = useSelector(
        (state) =>
            state.loginReducer.isAuthenticatedWithHybris ||
            JSON.parse(localStorage.getItem('userAuthenticated'))
    );

    const useStyles = makeStyles(() => ({
        toggle: {
            '& .Mui-checked': {
                color: '#1010EB',
            },
            '& .MuiSwitch-track': {
                backgroundColor: '#E7E7FD !important',
            },

            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                opacity: 1,
            },
        },
    }));
    const classes = useStyles();

    const createReceiveSets = useSelector(
        (state) => state.createReceiveSetsReducer?.createReceiveSets
    );
    const userRole = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.employeeRole
    );
    const isInReceiveSetSubmitScreen =
        createReceiveSets && createReceiveSets?.myCaseRef;

    // Handle window resize to update mobile view detection
    useEffectWithErrorLogging(() => {
        const handleResize = () => {
            setIsMobile(isMobileView() || isMobileDevice());
        };
 
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);
 
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);

    useEffectWithErrorLogging(() => {
        setHideCondensedViewState(isHideCondensedView);
        dispatch(setIsHideCondensedView(isHideCondensedView));
    }, [isHideCondensedView]);

    useEffectWithErrorLogging(() => {
        setHideCondensedViewState(hideCondensedView);
    }, [hideCondensedView]);

    useEffectWithErrorLogging(() => {
        if (isImpersonationActive) {
            // dispatch(setHeaderCondensedView(isImpersonatedCondensedView));
            setCondensedViewState(isImpersonatedCondensedView);
            dispatch(setIsCondensedView(isImpersonatedCondensedView));
        } else if (
            sessionStorage.getItem('isCondensedViewState') === 'true' ||
            sessionStorage.getItem('isCondensedViewState') === 'false'
        ) {
            const isCondensed = sessionStorage.getItem('isCondensedViewState') === 'true';
            dispatch(setIsCondensedView(isCondensed));
        } else {
            setCondensedViewState(condensedView);
            dispatch(setIsCondensedView(condensedView));
        }
    }, [condensedView, isImpersonatedCondensedView, isImpersonationActive]);


    useEffectWithErrorLogging(() => {
        if (
            sessionStorage.getItem('isCondensedViewState') === 'true' ||
            sessionStorage.getItem('isCondensedViewState') === 'false'
        ) {
            // setCondensedViewState(isHeaderCondensedView);
            setCondensedViewState(isCondensedView);
        } else {
            dispatch(setIsCondensedView(isCondensedView));
            setCondensedViewState(isCondensedView);
        }
    }, [isCondensedView]);

    // Save the condensed view state to session storage whenever it changes
    useEffectWithErrorLogging(() => {
        if(isImpersonationActive){
            sessionStorage.setItem(
                'isCondensedViewStateInImpersonation',
                JSON.stringify(condensedViewState)
            );
        } else{
            sessionStorage.setItem(
                'isCondensedViewState',
                JSON.stringify(condensedViewState)
            );
        }
    }, [condensedViewState]);

    useEffectWithErrorLogging(() => {
        setBannerDisplay(infoBanner);
    }, [infoBanner]);

    useEffectWithErrorLogging(() => {
        setConfirmationMessage(confirmationBanner);
    }, [confirmationBanner]);

    useEffectWithErrorLogging(() => {
        if (isImpersonationActive) {
            setIsImpersonated(checkImpersonationActive());
        }
    }, [isImpersonationActive]);

    useEffectWithErrorLogging(() => {
        if (isDestructive) {
            history.push(getRoutePathWithParams('/maintainance'));
            return;
        }
        callSetBannerDisplay();
        checkConfirmeMessage();
    }, [bannerInfo]);
    const accountSearchOpen = useSelector(
        (state) => state.accountReducer.accountSearchOpen
    );
    useEffectWithErrorLogging(() => {
        if (ImpersonationEndStatus === '200') {
            removeImperonatedUserDetail();
            localStorage.removeItem('persist:impersonationUserKey');
            window.setTimeout(function () {
                window.location.replace(
                    `${getWcmsHostName()}?terminateImpersonation=true`
                );
            }, 0);
        }
    }, [ImpersonationEndStatus]);

    useEffectWithErrorLogging(() => {
        if (adminImperonationEndStatus === '200') {
            localStorage.setItem(
                'baseSiteId',
                localStorage.getItem('userBaseSiteId')
            );
            localStorage.removeItem('userBaseSiteId');
            sessionStorage.removeItem('ProxyUser');
            sessionStorage.setItem('impersonationEndFlag', true);
            removeImperonatedUserDetail();
            localStorage.removeItem('persist:impersonationUserKey');
            dispatch(
                setImpersonateCheckAction({
                    isImpersonationActive: false,
                })
            );
            dispatch(getBannerDetails());
            dispatch(getHybrisUserDetails());
            dispatch(getConfigurations({resourceType: 'PROCESS'}, MENU));
            dispatch(getPageVisibilityRule({ fields: 'BASIC' }));
            dispatch(
                setFilters({
                    filterParam: '',
                })
            );
            dispatch(resetCalendarFilterDataAfterImpersonation());
            restoreAccountFilterStateAfterImpersonation(dispatch);
            restorePhysicianFilterStateAfterImpersonation(dispatch);
            restoreOrderFilterStateAfterImpersonation(dispatch);
            history.push(
                userRole === FIA_USER_ROLE || userRole === FIM_USER_ROLE
                    ? '/adminView'
                    : '/'
            );
        }
    }, [adminImperonationEndStatus]);

    useEffectWithErrorLogging(() => {
        if (Number(bannerFrequency)) {
            intervalId && clearInterval(intervalId);
            const id = setInterval(() => {
                if(!isAuthenticated){
                    intervalId && clearInterval(intervalId);
                    return;
                }
                dispatch(getBannerDetails());
            }, (bannerFrequency / 60 + (bannerFrequency % 60)) * 60000);
            setIntervalId(id);
            return () => {
                intervalId && clearInterval(intervalId);
            };
        } else {
            intervalId && clearInterval(intervalId);
        }
    }, [bannerFrequency]);

    const checkConfirmeMessage = () => {
        let confirmationMessages = [];
        if (bannerInfo) {
            confirmationMessages = bannerInfo.filter(
                (item) => item.messageType === 'userConfirmMessage'
            );
        }
        setConfirmationMessage(confirmationMessages);
    };

    useEffectWithErrorLogging(() => {
        if (confirmationMessage.length > 0) {
            setShowConfirmationMsg(true);
        }
    }, [confirmationMessage]);
    const callSetBannerDisplay = () => {
        let userInfoMessages = [];
        if (bannerInfo) {
            userInfoMessages = bannerInfo.filter(
                (item) => item.messageType === 'userInfoMessage'
            );
        }
        setBannerDisplay(userInfoMessages);
    };
    const employeeRole = getUserDetails();
    const titleTagClickHandler = () => {
        dispatch(
            setActiveNavLink({
                dashboard: false,
                calendar:
                    employeeRole === CC_USER_ROLE ||
                    employeeRole === ITA_USER_ROLE ||
                    employeeRole === FIM_USER_ROLE ||
                    employeeRole === FIA_USER_ROLE ||
                    employeeRole === CSR_USER_ROLE
                        ? false
                        : true,
                admin:
                    employeeRole === CC_USER_ROLE ||
                    employeeRole === ITA_USER_ROLE
                        ? true
                        : false,
                orders: employeeRole === CSR_USER_ROLE ? true : false,
                alerts: false,
                inventory:
                    employeeRole === FIM_USER_ROLE ||
                    employeeRole === FIA_USER_ROLE
                        ? true
                        : false,
                more: false,
            })
        );
    };

    const onDismissClick = (data = {}) => {
        if (checkProxyActive() || checkImpersonationActive()) {
            setBannerDisplay([]);
            dispatch(showDismissedBanner());
            const filteredBannerData = (bannerDisplay || []).filter(
                (it) => it.messageCode !== data.messageCode
            );
            setBannerDisplay(filteredBannerData);
            dispatch(updateBannerLength(filteredBannerData));
            const url = `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/calendar/hidebannerinfo?messageCode=${
                data.messageCode
            }&messageType=${data.messageType}`;
            axios.put(url).then((res) => {
                if (
                    res &&
                    res.data &&
                    res.data.statusMessage !== 'Banner hide successful.'
                ) {
                    callSetBannerDisplay();
                    dispatch(updateBannerLength(1));
                }
            });
            dispatch(updateBannerLength(1));
        } else {
            if (data.messageType === 'userInfoMessage') {
                dispatch(showDismissedBanner());
                const filteredBannerData = (bannerDisplay || []).filter(
                    (it) => it.messageCode !== data.messageCode
                );
                setBannerDisplay(filteredBannerData);
                dispatch(updateBannerLength(filteredBannerData));
                const url = `/occ/v2/${localStorage.getItem(
                    'baseSiteId'
                )}/calendar/hidebannerinfo?messageCode=${
                    data.messageCode
                }&messageType=${data.messageType}`;
                axios.put(url).then((res) => {
                    if (
                        res &&
                        res.data &&
                        res.data.statusMessage !== 'Banner hide successful.'
                    ) {
                        callSetBannerDisplay();
                        dispatch(updateBannerLength(1));
                    }
                });
            }
        }
    };

    const impersonationDoneHandler = () => {
        dispatch(clearProductsGuideData());
        dispatch(getFilterData(sessionStorage.getItem('FilterDataOpen')));
        dispatch(updateFilter());
        const storedArray = JSON.parse(sessionStorage.getItem('items')); //no brackets
        dispatch(setFilterAppliedView(storedArray));
        dispatch(setPopDone(false));
        const selectedArray = JSON.parse(
            sessionStorage.getItem('selectedViews')
        ); //no brackets
        const selectedFilter = JSON.parse(
            sessionStorage.getItem('appliedData')
        ); //no brackets
        selectedFilter && dispatch(setAppliedFilter(selectedFilter));
        selectedArray && dispatch(setSelectedViews(selectedArray));

        selectedFilter &&
            dispatch(
                setAdminFilterParamValues({
                    filteredSalesOrgView:
                        selectedFilter.appliedsalesOrgView.name === 'All'
                            ? ''
                            : selectedFilter.appliedsalesOrgView.value,
                    filteredDistrict:
                        selectedFilter.appliedDistrict.name === 'All Districts'
                            ? ''
                            : selectedFilter.appliedDistrict.id,
                    filteredTerritory:
                        selectedFilter.appliedTerritory.name ===
                        'All Territories'
                            ? ''
                            : selectedFilter.appliedTerritory.id,
                    filteredRole:
                        selectedFilter.appliedRole.name === 'All'
                            ? ''
                            : selectedFilter.appliedRole.id,
                })
            );
        const ProxyUser = sessionStorage.getItem('ProxyUser');
        if (ProxyUser) {
            dispatch(terminateAdminImpersonation());
        } else {
            dispatch(invalidateImpersonation());
        }
        dispatch(setFilterAfterImpersonation(true));
        dispatch(getFilterData(true));
    };
    const proxyDoneHandler = () => {
        dispatch(terminateProxy());
        dispatch(resetBannerData());
        // window.location.reload();
    };
    useEffectWithErrorLogging(() => {
        if (proxyTerminationStatus === '200') {
            // window.location.reload();
            localStorage.setItem(
                'baseSiteId',
                localStorage.getItem('userBaseSiteId')
            );
            localStorage.removeItem('userBaseSiteId');
            sessionStorage.removeItem('ProxyUser');
            sessionStorage.removeItem('ProxyUserRole');
            sessionStorage.removeItem('ProxyimpersonationKey');
            sessionStorage.removeItem('ProxyDistrict');
            dispatch(getHybrisUserDetails());
            dispatch(getConfigurations({resourceType: 'PROCESS'}, MENU));
            dispatch(getPageVisibilityRule({ fields: 'BASIC' }));
            // Re-fetch the base user's banner after ending the proxy.
            // resetBannerData() cleared both the proxy and info banners, and
            // baseSiteId has just been restored to the base user's site, so the
            // base user's info banner must be fetched again to reappear.
            dispatch(getBannerDetails());
            restoreAccountFilterStateAfterImpersonation(dispatch);
            restorePhysicianFilterStateAfterImpersonation(dispatch);
            restoreOrderFilterStateAfterImpersonation(dispatch);
            history.push('/');
        }
    }, [proxyTerminationStatus]);
    /*
    openAnnouncementSceen:: method has usuage inside html content. Please dont remove it. 
    */
    const openAnnouncementSceen = () => {
        dispatch(hideDismissedBanner());
        history.push({
            ...getRoutePathWithParams('/announcements'),
        });
    };

    useEffectWithErrorLogging(() => {
        let animationId;
        if (dismissedBanner) {
            setShowAnimation(false);
            animationId = setTimeout(() => {
                setShowAnimation(true);
                dispatch(hideDismissedBanner());
            }, 7000);
        }
        return () => {
            setShowAnimation(false);
            animationId && clearTimeout(animationId);
        };
    }, [dismissedBanner]);

    useEffectWithErrorLogging(() => {
        if (showAnimation) {
            let id = setTimeout(() => {
                dispatch(hideDismissedBanner());
            }, [2000]);
            setAnimationId(id);
        }
        return () => {
            animationId && clearTimeout(animationId);
        };
    }, [showAnimation]);

    const renderProxyBanner = () => {
        if (
            // proxyImpersonationKey ||
            // sessionStorage.getItem('ProxyimpersonationKey')
            checkProxyActive()
        ) {
            const ProxyUser = sessionStorage.getItem('ProxyUser');
            const ProxyUserRole = sessionStorage.getItem('ProxyUserRole');

            return (
                <Banner
                    title={`Proxying for ${ProxyUser} `}
                    subtitle={ProxyUserRole}
                    subtitleFontSize="12px"
                    width={'75%'}
                    proxyBackgroundColor
                    clicked={() => proxyDoneHandler()}
                />
            );
        }
    };

    const renderBanner = () => {
        if (dismissedBanner) {
            return (
                <DismissContainer animate={showAnimation}>
                    <Banner
                        renderAnnouncement={() => (
                            <p
                                style={{
                                    color: '#140F4B',
                                    fontFamily: 'AvenirNextWorld Demi',
                                    fontSize: '13px',
                                }}
                            >
                                {t('common.bannerText')}{' '}
                                <a
                                    onClick={openAnnouncementSceen}
                                    style={{
                                        cursor: 'pointer',
                                        color: '#1010EB',
                                    }}
                                >
                                    {t('moreNavLink.announcementsLabel')}
                                </a>{' '}
                                {t('common.section')}
                            </p>
                        )}
                        width={'90%'}
                        messageType={'announcement'}
                    />
                </DismissContainer>
            );
        }
        // return bannerDisplay.map((item) => {
        //     return (
        //         <Banner
        //             key={item.messageCode}
        //             content={item.messageText || item.descriptionText}
        //             width={'90%'}
        //             messageType={item.messageType}
        //             clicked={() => onDismissClick(item)}
        //         />
        //     );
        // });

        return (
            bannerDisplay?.length > 0 && (
                <Banner
                    key={bannerDisplay[0]?.messageCode}
                    content={
                        bannerDisplay[0]?.messageText ||
                        bannerDisplay[0]?.descriptionText
                    }
                    width={'90%'}
                    messageType={bannerDisplay[0]?.messageType}
                    clicked={() => {
                        try {
                        onDismissClick(bannerDisplay[0]);
                        let banner = bannerDisplay?.slice(1);
                        setBannerDisplay(banner);
                         } catch (error) {
                               logErrorToConsole(error);
                         }
                    }}
                />
            )
        );
    };

    const getImpersonatedBannerSubtitle = () => {
        const principalUser = sessionStorage.getItem('impersonatedUserId');
        let districtLabel = '';

        switch (impersonatedUserDistricts.length) {
            case 0:
                districtLabel = '';
                break;
            case 1:
                districtLabel = (
                    <span>
                        {' '}
                        | {isMobileDevice() && <br />}
                        {impersonatedUserDistricts[0]}
                    </span>
                );
                break;
            default:
                districtLabel = (
                    <>
                        {' '}
                        | {isMobileDevice() && <br />}{' '}
                        {impersonatedUserDistricts[0]}
                        <StyledMoreDistrictSpan>
                            {' '}
                            + {impersonatedUserDistricts.length - 1}{' '}
                            {t('common.moreLabel')}
                        </StyledMoreDistrictSpan>
                    </>
                );
        }

        return (
            <>
                <span className="navigation-impersonated-user-id-dt-mask">{principalUser}</span> | {impersonatedUserRole} {districtLabel}
            </>
        );
    };

    const renderImpersonatedBanner = () => {
        if (isImpersonationActive) {
            return (
                <Banner
                    title={<>{t('common.impersonating')}{'  '}<span className="navigation-impersonated-person-name-dt-mask">{
                        proxyUserImpersonation
                            ? proxyUserImpersonation !== 'undefined undefined'
                                ? proxyUserImpersonation
                                : ''
                            : impersonatedUserName
                            ? impersonatedUserName
                            : ''
                    }</span></>}
                    subtitle={getImpersonatedBannerSubtitle()}
                    subtitleFontSize={X_SMALL_TEXT_PX}
                    width={'75%'}
                    adminImpersonateBGColor
                    clicked={() => impersonationDoneHandler()}
                />
            );
        }
    };

    const onClose = () => {
        setShowConfirmationMsg(false);
        if (checkProxyActive() || checkImpersonationActive()) {
            const confirmObj = confirmationMessage[0];
            // setConfirmationMessage([]);
            const url = `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/calendar/hidebannerinfo?messageCode=${
                confirmObj.messageCode
            }&messageType=${confirmObj.messageType}`;
            axios.put(url).then((res) => {
                if (
                    res &&
                    res.data &&
                    res.data.statusMessage === t('common.bannerHideSuccessful')
                ) {
                    let msg = [...confirmationMessage];
                    setConfirmationMessage(msg.slice(1));
                    setShowConfirmationMsg(msg?.length > 0 ? true : false);
                    // window.location.reload();
                    resumeScrolling();
                }
            });
        } else {
            const confirmObj = confirmationMessage[0];
            const url = `/occ/v2/${localStorage.getItem(
                'baseSiteId'
            )}/calendar/hidebannerinfo?messageCode=${
                confirmObj.messageCode
            }&messageType=${confirmObj.messageType}`;
            axios.put(url).then((res) => {
                if (
                    res &&
                    res.data &&
                    res.data.statusMessage === t('common.bannerHideSuccessful')
                ) {
                    let msg = [...confirmationMessage];
                    setConfirmationMessage(msg.slice(1));
                    setShowConfirmationMsg(msg?.length > 0 ? true : false);
                    // window.location.reload();
                    resumeScrolling();
                }
            });
        }
    };
    useEffectWithErrorLogging(() => {
        if (confirmationMessage?.length > 0) {
            hideScrolling();
        }
    }, [confirmationMessage]);

    useEffectWithErrorLogging(() => {
        if (confirmationMessage?.length > 0) {
            hideScrolling();
        }
    }, []);

    const condensedViewToggleHandler = () => {
        setCondensedViewState(!condensedViewState);
        dispatch(setIsCondensedView(!condensedViewState));
        // dispatch(setHeaderCondensedView(!condensedViewState));
    };

    // const returntoWCMS = () => {
    //     window.setTimeout(function () {
    //         window.location.replace(
    //             `${
    //                 process.env.WCMS_HOST_NAME
    //             }/?impersonatedFlag=true&impersonatedUser=${sessionStorage.getItem(
    //                 'impersonatedUserId'
    //             )}`
    //         );
    //     }, 0);
    // };
    return (
        <>
            <HeaderWrapper accountSearchOpen={accountSearchOpen}>
                <div ref={props.bannerRef}>
                    {renderBanner()}
                    {renderImpersonatedBanner()}
                    {renderProxyBanner()}
                </div>
                <HeaderDiv
                    isBanner={
                        bannerDisplay?.length > 0 ||
                        dismissedBanner ||
                        isImpersonated ||
                        checkProxyActive()
                    }
                    dynamicZIndex={newZIndex}
                >
                    <div
                        style={{ cursor: 'pointer' }}
                        onClick={props.openSideNavBar}
                    >
                        <HamBurgerButton
                            className="menu"
                            onClick={props.openSideNavBar}
                            userDetailsAvailable={userDetailsAvailable}
                        >
                            {totalDeniedOrder > 0 && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '89%',
                                        left: '55%',
                                        transform: 'translate(7%, -145%)',
                                        backgroundColor: '#12C8F7',
                                        color: '#140f4b',
                                        borderRadius: '50%',
                                        border: '1px solid #140f4b',
                                        height: '14px',
                                        width: '14px',
                                    }}
                                ></div>
                            )}
                            <span />
                            <span />
                            <span />
                        </HamBurgerButton>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <TitleTag
                            onClick={() =>
                                !isDestructive && titleTagClickHandler()
                            }
                            userDetailsAvailable={userDetailsAvailable}
                            cursor={isDestructive ? 'default' : 'cursor'}
                        >
                            {
                                // (!checkImpersonationActive() &&
                                //     employeeRole === FIM_USER_ROLE) ||
                                // (checkImpersonationActive() &&
                                //     sessionStorage.getItem('ProxyUserRole') ===
                                //         FIM_USER_ROLE) ? (
                                //     <Link
                                //         onClick={(e) => {
                                //             !isDestructive &&
                                //                 // returntoWCMS();
                                //                 navigateWithBusinessLogic(
                                //                     e,
                                //                     sideNavLinksWCMSLinks(
                                //                         'dashboard'
                                //                     ),
                                //                     'dashboard',
                                //                     surgeryCUInProgress,
                                //                     settingUpdateInProgress,
                                //                     dispatch,
                                //                     setRoutePathForSSUnsavedChangesPopUp,
                                //                     setScheduleSurgeryUnsavedChangesPopUp,
                                //                     history,
                                //                     navLinkSelectHandler,
                                //                     setActiveNavLink,
                                //                     false, // clicked fn
                                //                     setShowUnsavedReportUsageChangesPopUp,
                                //                     isInReportUsageSubmitScreen,
                                //                     isCancelUsageSubmitted,
                                //                     equityCUInProgress,
                                //                     setRoutePathForEquityUnsavedChangesPopUp,
                                //                     setEquityUnsavedChangesPopUp,
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     '',
                                //                     setReceiveSetUnsavedChangesPopup,
                                //                     setRoutePathForReceiveSetUnsavedChangesPopUp,
                                //                     '',
                                //                     isInReceiveSetSubmitScreen,
                                //                     consignmentAddCUInProgress,
                                //                     setConsignmentAddUnsavedChangesPopUp,
                                //                     setRoutePathForConsignmentAddUnsavedChangesPopUp
                                //                 );
                                //         }}
                                //     >
                                //         My<span>CASE</span>
                                //     </Link>
                                // ) :
                                <Link
                                    to={
                                        !isDestructive
                                            ? getRoutePathWithParams(
                                                  // (!checkImpersonationActive() &&
                                                  //     (employeeRole === CC_USER_ROLE ||
                                                  //         employeeRole === ITA_USER_ROLE)) ||
                                                  //     (checkImpersonationActive() &&
                                                  //         (sessionStorage.getItem(
                                                  //             'ProxyUserRole'
                                                  //         ) === CC_USER_ROLE ||
                                                  //             sessionStorage.getItem(
                                                  //                 'ProxyUserRole'
                                                  //             ) === ITA_USER_ROLE))
                                                  //     ? '/admin'
                                                  //     :
                                                  '/'
                                              )
                                            : null
                                    }
                                    onClick={(e) => {
                                        !isDestructive &&
                                            navigateWithBusinessLogic(
                                                setDeniedOverrideClicked,
                                                e,
                                                // (!checkImpersonationActive() &&
                                                //     (employeeRole === CC_USER_ROLE ||
                                                //         employeeRole ===
                                                //             ITA_USER_ROLE)) ||
                                                //     (checkImpersonationActive() &&
                                                //         (sessionStorage.getItem(
                                                //             'ProxyUserRole'
                                                //         ) === CC_USER_ROLE ||
                                                //             sessionStorage.getItem(
                                                //                 'ProxyUserRole'
                                                //             ) === ITA_USER_ROLE))
                                                //     ? '/admin'
                                                //     :
                                                '/',
                                                employeeRole ===
                                                    FIA_USER_ROLE ||
                                                    employeeRole ===
                                                        FIM_USER_ROLE
                                                    ? '/receiveSets'
                                                    : employeeRole ===
                                                      CSR_USER_ROLE
                                                    ? '/orders'
                                                    : 'calendar',
                                                surgeryCUInProgress,
                                                settingUpdateInProgress,
                                                dispatch,
                                                setRoutePathForSSUnsavedChangesPopUp,
                                                setScheduleSurgeryUnsavedChangesPopUp,
                                                history,
                                                navLinkSelectHandler,
                                                setActiveNavLink,
                                                false, // clicked fn
                                                setShowUnsavedReportUsageChangesPopUp,
                                                isInReportUsageSubmitScreen,
                                                isCancelUsageSubmitted,
                                                equityCUInProgress,
                                                setRoutePathForEquityUnsavedChangesPopUp,
                                                setEquityUnsavedChangesPopUp,
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                '',
                                                setReceiveSetUnsavedChangesPopup,
                                                setRoutePathForReceiveSetUnsavedChangesPopUp,
                                                '',
                                                isInReceiveSetSubmitScreen,
                                                consignmentAddCUInProgress,
                                                setConsignmentAddUnsavedChangesPopUp,
                                                setRoutePathForConsignmentAddUnsavedChangesPopUp
                                            );
                                    }}
                                >
                                    {t('common.my')}
                                    <span>{t('common.case')}</span>
                                </Link>
                            }
                        </TitleTag>
                        {isMobile ? (
                            (!hideCondensedViewState) && (
                                <CondensedViewToggleButton>
                                    <Switch
                                        checked={condensedViewState}
                                        onChange={condensedViewToggleHandler}
                                        // color="primary"
                                        name="isCondensedView"
                                        inputProps={{
                                            'Condensed View':
                                                'primary checkbox',
                                        }}
                                        className={classes.toggle}
                                    />
                                    <SwitchLable>
                                        {t('settings.condensedView')}
                                    </SwitchLable>
                                </CondensedViewToggleButton>
                            )
                        ) : (
                            <UserProfileContainer
                                userDetailsAvailable={userDetailsAvailable}
                            >
                                {(!hideCondensedViewState) && (
                                    <CondensedViewToggleButton>
                                        <Switch
                                            checked={condensedViewState}
                                            onChange={
                                                condensedViewToggleHandler
                                            }
                                            // color="primary"
                                            name="isCondensedView"
                                            inputProps={{
                                                'Condensed View':
                                                    'primary checkbox',
                                            }}
                                            className={classes.toggle}
                                        />
                                        <SwitchLable>
                                            {t('settings.condensedView')}
                                        </SwitchLable>
                                    </CondensedViewToggleButton>
                                )}
                                <UserPanel
                                    clicked={props.closeSideNavBar}
                                    hasBanner={bannerDisplay?.length > 0}
                                />
                            </UserProfileContainer>
                        )}
                    </div>
                </HeaderDiv>
            </HeaderWrapper>
            {showConfirmationMsg && confirmationMessage?.length > 0 && (
                <ConfirmationPopUp
                    onClose={() => onClose()}
                    confirmationMessage={confirmationMessage}
                />
            )}
        </>
    );
};

export default Header;
